import React from 'react';
import {Glob as G} from "../libs/Glob.mjs";
import {Button, InputGroup, InputGroupText} from "reactstrap";
import UploadIcon from "../media/images/UploadIcon.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import DownloadIcon from "../media/images/DownloadIcon.mjs";
import appLib from "../libs/appLib.mjs";
import FileIcon from "../media/images/FileIcon.mjs";
import ListIcon from "../media/images/ListIcon.mjs";

const prefix = 'AdminSettings';

const AdminSettings = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { countAteco: '' };
		this.uid = G.generateUid(prefix);
		this.refreshAteco = this.refreshAteco.bind(this);
		this.uploadAteco = this.uploadAteco.bind(this);
	}
	componentDidMount() {
		setTimeout( this.refreshAteco );
	}
	/**
	 * Refresh the count of ATECO codes, sets state
	 * @param {boolean} [force] Force refreshing
	 * @return { Promise<object> } The ATECO file content
	 */
	refreshAteco( force= false ) {
		return new Promise( ( resolve, reject ) => {
			appLib.getAtecoList( force ).then((data) => {
				this.setState({countAteco: Object.keys(data).length }, ()=>{
					resolve(data);
				});
			}).catch( e => {
				reject(e);
			});
		})
	}

	/**
	 * Pick a JSON and upload it as the new ATECO list
	 * @return {void}
	 */
	uploadAteco() {
		G.uploadJSON().then( data =>{
			this.setState({countAteco: '', uploading: true },()=>{
				G.api('admin/setAtecoList', data )
					.catch( e =>{
						console.error(e);
						window.alert( e )
					})
					.finally(()=>{
						this.refreshAteco(true).then( () =>{
							this.setState({ uploading: false });
						});
					})
			});
		});
	}

	render() {
		return(
			<div className={prefix} id={this.uid}>
				<InputGroup>
					<InputGroupText>
						<FileIcon />
						<TextLabel value={"ATECO codes"} />:
					</InputGroupText>
					<InputGroupText>
						<Button
							disabled={ this.state.uploading }
							className="btn-icon"
							color={"warning"}
							onClick={ this.uploadAteco }
						>
							<i>
								<UploadIcon />
							</i>
							<b>
								<TextLabel value={"Upload"} />
							</b>
						</Button>
					</InputGroupText>
					<InputGroupText>
						<Button
							disabled={ ! this.state.countAteco || this.state.uploading }
							className="btn-icon"
							color={"primary"}
							onClick={ ()=>{
								appLib.getAtecoList().then( data =>{
									G.saveJSON( data, 'codici-ateco.json');
								})
							}}
						>
							<i>
								<DownloadIcon />
							</i>
							<b>
								<TextLabel value={"Download"} />
							</b>
						</Button>
					</InputGroupText>
					<InputGroupText>
						<ListIcon />
						<TextLabel value={"ATECO entries"} />: { this.state.countAteco || '—' }
					</InputGroupText>
				</InputGroup>
			</div>
		)
	}
}

export default AdminSettings;